const CURRENT_ORIGIN = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (rawUrl) => {
  if (!rawUrl) return "";
  if (rawUrl.startsWith("data:")) return rawUrl;

  try {
    const parsed = new URL(rawUrl, CURRENT_ORIGIN);
    if (parsed.pathname.startsWith("/api/uploads/")) {
      return `${CURRENT_ORIGIN}${parsed.pathname}`;
    }
    return parsed.toString();
  } catch {
    return rawUrl;
  }
};